export default __webpack_public_path__ + "static/blueray_2-3cf04ff0c34626f0add7bca7da602d0d.png";